import { s3BucketTypes } from '@constants/index';
import { otherTypes } from '../constants';
import { paginatorResultsSchema } from '../schemas';

export const fetchFaqs = () => ({
  type: otherTypes.FETCH_FAQS,
  endpoint: 'v1/faq/?type=2',
  method: 'get'
});

export const fetchS3SignInUrl = (
  fileName,
  type = 0,
  uid = '',
  contentType
) => ({
  type: otherTypes.FETCH_S3_SIGNIN_URL,
  endpoint: `v1/s3_url/?objectName=${encodeURIComponent(
    fileName
  )}&type=${type}${uid ? `&uid=${uid}` : ''}${
    contentType ? `&contentType=${contentType}` : ''
  }`,
  method: 'get'
});

export const submitIssue = (data) => ({
  type: otherTypes.SUBMIT_ISSUE,
  endpoint: 'v1/user/me/report_bug/',
  method: 'post',
  data
});

export const fetchLegendsBanner = () => ({
  type: otherTypes.FETCH_LEGENDS_BANNER,
  endpoint: 'v1/feeds/banners/',
  method: 'get'
});

export const fetchSiteMap = () => ({
  type: otherTypes.FETCH_SITEMAP,
  endpoint: 'v1/html_sitemap/',
  method: 'get'
});

export const fetchConstants = () => {
  return {
    type: otherTypes.FETCH_CONSTANTS,
    endpoint: 'v1/constants/?platform=0',
    method: 'get'
  };
};

export const fetchIconicSubscriptionInfo = (key) => ({
  type: otherTypes.FETCH_ICONIC_SUBSCRIPTION_INFO,
  endpoint: `subscription-info/${key}`,
  method: 'get',
  iconicKey: key,
  isCMS: true
});

export const fetchSubscriptionFeatures = (key) => ({
  type: otherTypes.FETCH_SUBSCRIPTION_FEATURES,
  endpoint: `subscription-features/${key}`,
  method: 'get',
  isCMS: true
});

export const fetchSubscriptionHighlights = (key) => ({
  type: otherTypes.FETCH_SUBSCRIPTION_HIGHLIGHTS,
  endpoint: `subscription-highlights/${key}`,
  method: 'get',
  isCMS: true
});

export const fetchPriceHikeInfo = () => ({
  type: otherTypes.FETCH_PRICE_HIKE_INFO,
  endpoint: 'active-price-hikes',
  method: 'get',
  isCMS: true
});

export const fetchSubscriptionFaqs = (key) => ({
  type: otherTypes.FETCH_SUBSCRIPTION_FAQS,
  endpoint: `subscription-faqs/${key}`,
  method: 'get',
  isCMS: true
});

export const fetchOneCarouselFeed = () => ({
  type: otherTypes.FETCH_ONE_CAROUSEL_FEED,
  endpoint: 'v1/feeds/carousel',
  method: 'get',
  entityType: 'feedrow',
  schema: paginatorResultsSchema
});

export const fetchRootPageData = () => ({
  type: otherTypes.FETCH_ROOT_PAGE_DATA,
  endpoint: 'api/root-page',
  method: 'get',
  isCMS: true
});

export const fetchABExperimentData = (experiment, jwtToken) => ({
  type: otherTypes.FETCH_AB_EXPERIMENT_DATA,
  endpoint: 'activate',
  method: 'post',
  data: {
    experiment_name: experiment
  },
  isABserver: true,
  headers: {
    authorization: `Bearer ${jwtToken}`
  },
  experimentKey: experiment
});

export const uploadFile = (
  url,
  file_name,
  doc_type = s3BucketTypes.LEARNER_NOTES
) => ({
  type: otherTypes.UPLOAD_FILE,
  endpoint: 'v1/uploads/document/',
  method: 'post',
  data: {
    url,
    file_name,
    doc_type
  }
});
